const typographyModalPlaces = {
  true: 'Edit ',
  false: 'Register ',
  text: 'Source'
};

export default typographyModalPlaces;
